import {Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'gastos',
})
export class GastosPipe implements PipeTransform {

  transform(items: any[], filter: any[]) {

    if (0) {
      if (filter['id_local'] && filter['id_local'] > 0) {

        items = items.filter(function (item) {
          return item.id_local == filter['id_local'];
        });
      }
    }

    return items;

  }

}



// WEBPACK FOOTER //
// ./src/pipes/gastos/gastos.ts